import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import React from "react";
import CustomCard from "../../../UI/CustomCard/CustomCard";
import useUniqueId from "../../../Hooks/useUniqueId";
import FAIcon from "../../../UI/FAIcon/FAIcon";
import LinkToPerson from "../../../Presentational/Person/LinkToPerson/LinkToPerson";
import DateService from "../../../../Services/Shared/Date.service";
import BooleanDisplay from "../../../UI/BooleanDisplay/BooleanDisplay";
const shouldShowItem = (item) => !!(item === null || item === void 0 ? void 0 : item.value);
const InfoItemDisplay = (item) => {
    const shouldShow = shouldShowItem(item);
    const makeId = useUniqueId()[1];
    if (!shouldShow) {
        return null;
    }
    return (_jsxs("div", { className: "form-group", children: [_jsx("label", { htmlFor: makeId(item.title), className: "mb-0", children: item.title }), _jsx("div", { id: makeId(item.title), children: item.value })] }));
};
const InfoItems = ({ items }) => {
    return (_jsx("div", { className: "row", children: items.map(
        // @ts-expect-error - TS7006 - Parameter 'item' implicitly has an 'any' type. | TS7006 - Parameter 'i' implicitly has an 'any' type.
        (item, i) => item &&
            shouldShowItem(item) && (_jsx("div", { className: "col-md-6", children: _jsx(InfoItemDisplay, { title: item.title, value: item.value }, i) }))) }));
};
const CampaignTemplateInfo = (props) => {
    const items = [
        // @ts-expect-error - TS2322 - Type '{ title: string; value: string | null | undefined; }' is not assignable to type 'undefined'.
        { title: "Description", value: props.template.description },
        // @ts-expect-error - TS2322 - Type '{ title: string; value: JSX.Element; }' is not assignable to type 'undefined'.
        {
            title: "Body",
            value: (_jsxs("a", { href: "/aviso/contentTemplate/body/" + props.template.id, target: "_blank", rel: "noopener noreferrer", children: ["View Body ", _jsx(FAIcon, { icon: "external-link" })] })),
        },
        // @ts-expect-error - TS2322 - Type '{ title: string; value: JSX.Element; }' is not assignable to type 'undefined'.
        {
            title: "Created",
            value: (_jsxs(_Fragment, { children: [DateService.displayWithTime(props.template.createdDate), " ", props.template.createdBy && (_jsxs(_Fragment, { children: ["-", " ", _jsx(LinkToPerson, { affiliationId: props.template.createdBy.affiliationId, name: props.template.createdBy.fullName, children: props.template.createdBy.fullName }), " "] }))] })),
        },
        // @ts-expect-error - TS2322 - Type '{ title: string; value: JSX.Element; }' is not assignable to type 'undefined'.
        {
            title: "Modified",
            value: (_jsxs(_Fragment, { children: [DateService.displayWithTime(props.template.modifiedDate), " ", props.template.modifiedBy && (_jsxs(_Fragment, { children: ["-", " ", _jsx(LinkToPerson, { affiliationId: props.template.modifiedBy.affiliationId, name: props.template.modifiedBy.fullName, children: props.template.modifiedBy.fullName }), " "] }))] })),
        },
        // @ts-expect-error - TS2322 - Type '{ title: string; value: any; }' is not assignable to type 'undefined'. | TS2339 - Property 'campaignTypeName' does not exist on type 'GenericContentTemplate'.
        { title: "Type", value: props.template.campaignTypeName },
        // @ts-expect-error - TS2322 - Type '{ title: string; value: JSX.Element; }' is not assignable to type 'undefined'.
        {
            title: "Drag and Drop",
            value: _jsx(BooleanDisplay, { val: props.template.isDragAndDrop }),
        },
    ];
    return (_jsx(_Fragment, { children: _jsx(CustomCard, { title: "Info", children: _jsx("div", { className: "card-body", children: _jsx(InfoItems, { items: items }) }) }) }));
};
export default CampaignTemplateInfo;
